// src/pages/shrines/ShrineOfImamAli.jsx
import React from 'react';

const ShrineOfImamAli = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Shrine of Imam Ali (AS) in Najaf</h1>
      <p>Explore the holy shrine and teachings of Imam Ali (AS) in Najaf, Iraq.</p>
    </div>
  );
};
export default ShrineOfImamAli;